export const FrameStatus = Object.freeze({
  Waiting: 1,
  Rendering: 2,
  Stop: 3,
  Done: 4,
  Failed: 5,
  WaitingForPreprocessingDone: 6,
  WaitingForPhotonFramesDone: 7,
  WaitingForTestFramesDone: 8,
  WaitingForPhotonJobDone: 9,
  WaitingForSimulationDone: 10,
  TimeoutStop: 11,
  WaitingSubFrame: 12,
})

export const FrameType = Object.freeze({
  Prepare: 1,
  Photon: 2,
  MergePhoton: 3,
  PriorityRender: 4,
  Render: 5,
  PriorityRenderMerge: 6,
  RenderMerge: 7,
  GopHoudini: 8,
  MaxChannel: 9,
  DistributedHoudini: 10,
  DistributedHoudiniMaster: 11,
  AdditionalFeature: 15,
  MayaSimulation: 16,
  GIAdditionalFeature: 17,
  MergeGIAdditionalFeature: 18,
})

export const AdditionalFrameTypeList = [
  FrameType.AdditionalFeature,
  FrameType.GIAdditionalFeature,
  FrameType.MergeGIAdditionalFeature,
]

export const TaskFlagType = Object.freeze({
  preTask: 2,
  renderFlag: 5,
  analysesFlag: 6,
})

export const TaskFlagTypeNew = {
  preTask: [2],
  renderFlag: [0, 1, 5],
  analysesFlag: [3, 4, 6],
}

export const typeList = [
  {value: 0, label: 'common_error_types_0'},
  {value: 1, label: 'common_error_types_1'},
  {value: 2, label: 'common_error_types_2'},
]

export const channelType = Object.freeze({
  Animation: 1,
  Web: 2,
  Picture: 3,
  Api: 4,
  Plugin: 8,
})

/*
 * 计费模式
 * PREPAID: 预付费，即包年包月
 * POSTPAID_BY_HOUR: 按小时后付费
 * CDHPAID: 独享子机
 * SPOTPAID: 竞价付费
 * CDCPAID: 专用集群付费
 */
export const BillingMode = Object.freeze({
  PREPAID: 'PREPAID',
  POSTPAID_BY_HOUR: 'POSTPAID_BY_HOUR',
  CDHPAID: 'CDHPAID',
  SPOTPAID: 'SPOTPAID',
  CDCPAID: 'CDCPAID',
})

export const BillingModeOptions = [
  {
    label: 'common_billing_mode_postpaid_by_hour',
    value: BillingMode.POSTPAID_BY_HOUR,
  },
  {
    label: 'common_billing_mode_spotpaid',
    value: BillingMode.SPOTPAID,
  },
]

/**
 * 任务操作类型
 * 1: 开始, 2: 停止, 4: 重提, 5: 删除
 */
export const TaskOperateType = Object.freeze({
  Start: 1,      // 开始
  Stop: 2,       // 停止
  Restart: 4,    // 重提
  Delete: 5,     // 删除
})

/**
 * 任务依赖类型（前置/后置/渲染）
 */
export const TaskTypeByDependency = Object.freeze({
  Pre: 'pre',      // 前置
  Post: 'post',    // 后置
  Render: 'render', // 渲染
})

/**
 * 任务检查类型
 * 0: 任务, 1: 帧任务
 */
export const TaskCheckType = Object.freeze({
  Task: 0,    // 任务
  Frame: 1,   // 帧任务
})
